import { useSelector } from "react-redux";
import { Container, Row, Card, Col } from "react-bootstrap";
import ProductTypeList from "./ProductTypeList";
import Loading from "./Loading";
import { RootState } from "../reducers";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../serviceWorker";

const Home = () => {
  const product_types = useSelector((state: RootState) => state.shop.product_types);
  const isLoading = useSelector((state: RootState) => state.shop.isLoading);

  return (
    <Container fluid>
      <Row className="g-1 mb-1">
        <Col xs={12} md={8}>
          <Link to={"/product-type/weekly"}>
            <Card border="light" style={{ backgroundColor: "rgb(0,0,0,0.6)" }}>
              <Card.Img src={PUBLIC_URL + "img/user/1/weekly.jpg"} />
            </Card>
          </Link>
        </Col>
        <Col xs={12} md={4}>
          <Link to={"/product-type/187"}>
            <Card border="light" style={{ backgroundColor: "rgb(0,0,0,0.6)" }}>
              <Card.Img src={PUBLIC_URL + "img/user/1/sale.jpg"} />
            </Card>
          </Link>
        </Col>
      </Row>
      {!isLoading && product_types?.length ?
        <ProductTypeList productTypes={product_types} />
        : <Loading />}
    </Container>
  );
};
export default Home;
